import React, {Component} from 'react';
import SubmitInput from '../Fields/SubmitInput';
import HeaderSteps from '../Fragments/HeaderSteps';
import EmploymentPeriod from './Sections/EmploymentPeriod';
import SaveForLaterModal from '../Fragments/SaveForLaterModal';
import Field from '../Field';
import { browserHistory } from 'react-router';
import FullPageSpinner from '../Fragments/FullPageSpinner';

let Quote = require('../Managers/Quote.js');
let HttpService = require('../Managers/HttpService');

export default class EmploymentDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tenantNumber: 1,
            isUnemployed: false,
            isCurrentEmploymentChanging: false,
            isSecondEmploymentChanging: false,
            isStudentOrUnemployedOnly: false,
            mustSelectFinancialRefereeTwo: false,
            mustSelectFinancialRefereeThree: false,
            termLength: window.localStorage.getItem('TenancyTerm') ? parseInt(window.localStorage.getItem('TenancyTerm')) : 12,
            showFinancialRefereeOne: false,
            financialRefereeOneType: null,
            showFinancialRefereeTwo: false,
            financialRefereeTwoType: null,
            showFinancialRefereeThree: false,
            financialRefereeThreeType: null,
            isFullPageSpinnerActive: false,
            allowRefereeTwo: true,
            allowRefereeThree: true,
        };
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);
    }

    componentWillUpdate() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    handleCurrentEmploymentChanging(v) {
        if (v === true) {
            this.setState({ isCurrentEmploymentChanging: true }, () => {
                Quote.set('financialRefereeStatus', 2, 'BaseIndividualApplication.financialReferees.1');
            });
        } else {
            this.setState({
                isCurrentEmploymentChanging: false,
                showFinancialRefereeTwo: false,
                secondFinancialRefereeType: null,
            });
        }
    }

    handleSecondEmploymentChanging(v) {
        if (v === true) {
            this.setState({ isSecondEmploymentChanging: true });
            // Force financialRefereeStatus
            Quote.set('financialRefereeStatus', 3, 'BaseIndividualApplication.financialReferees.2');
        } else {
            this.setState({
                isSecondEmploymentChanging: false,
                thirdFinancialRefereeType: null,
            });
        }
    }

    manualStepProgression() {
        this.setState({ isFullPageSpinnerActive: true });
        let inputComponents = [];

        this.childComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        }).map(c => {
            inputComponents = inputComponents.concat(c.getChildInputComponents());
        });

        inputComponents = inputComponents.concat(this.inputComponents).filter(c => {
            return (c !== undefined) && (c !== null);
        });

        inputComponents.map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        setTimeout(() => {
            this.setState({ isFullPageSpinnerActive: false });
            if (document.querySelectorAll('.has-error').length > 0) {
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                // remove empty financial referees from base individual application
                let financialRefs = [];

                if (Quote.getByPath('BaseIndividualApplication.financialReferees')) {
                    financialRefs = Quote.getByPath('BaseIndividualApplication.financialReferees').filter(ref => {
                        return (!window.uorn(ref.financialRefereeStatus) && !window.uorn(ref.financialRefereeType));
                    });

                    // Only reset the finref values if it's not an xpress
                    if (Quote.getByPath('BaseIndividualApplication.product.productId') !== 11) {
                        Quote.setByPath('BaseIndividualApplication.financialReferees', financialRefs);
                    }
                }

                browserHistory.push('/application/additional-details');
            }
        }, 1000);
    }

    /**
     * Sets state if the main source of income is changing and we want to
     * force the display of fields for financial referee two.
     *
     * @param v
     */
    mustSelectFinancialRefereeTwo(v) {
        this.setState({
            mustSelectFinancialRefereeTwo: v,
        });
    }

    /**
     * Sets state if the second source of income is changing and we want to
     * force the display of fields for financial referee three.
     *
     * @param v
     */
    mustSelectFinancialRefereeThree(v) {
        this.setState({
            mustSelectFinancialRefereeThree: v,
        });
    }

    /**
     * Sets whether or not we show financial referee fields for financial
     * referees 1 through 3, and sets a state for which sub-form to render
     * inside the EmploymentPeriod component.
     *
     * @param financialRefereeNumber
     * @param subFormType
     */
    handleSubFormVisibility(financialRefereeNumber, subFormType) {
        switch(parseInt(financialRefereeNumber)) {
            case 0:
                this.setState({
                    showFinancialRefereeOne: true,
                    financialRefereeOneType: parseInt(subFormType),
                });
                break;
            case 1:
                this.setState({
                    showFinancialRefereeTwo: true,
                    financialRefereeTwoType: parseInt(subFormType),
                });
                break;
            case 2:
                this.setState({
                    showFinancialRefereeThree: true,
                    financialRefereeThreeType: parseInt(subFormType),
                });
                break;
        }
    }

    resetOnIndependentMeans(callback) {
        Quote.deleteByPath('BaseIndividualApplication.financialReferees');

        this.setState({
            allowRefereeTwo: false,
            allowRefereeThree: false,
            showFinancialRefereeTwo: false,
            showFinancialRefereeThree: false,
            isCurrentEmploymentChanging: false,
            isSecondEmploymentChanging: false,
            mustSelectFinancialRefereeTwo: false,
            mustSelectFinancialRefereeThree: false,
        }, () => {
            if (callback) {
                callback();
            }
        });
    }

    /**
     * Set the default frequencyOfPay for the current financial referee in the
     * financial referees array.
     *
     * @param financialRefereeNumber
     * @param paymentFrequency
     */
    setDefaultPaymentFrequency(financialRefereeNumber, paymentFrequency) {
        Quote.setByPath('BaseIndividualApplication.financialReferees.' + financialRefereeNumber + '.frequencyOfPay', paymentFrequency);
    }

    handleFinancialRefereeTypeAndEmploymentStatusCallback(financialRefereeNumber, fieldName, v) {
        let chunk = 'BaseIndividualApplication.financialReferees.' + financialRefereeNumber;

        // Delete the details for this financial referee
        Quote.emptyByPath(chunk);

        // Set the financialRefereeType and force a default frequencyOfPay
        // (where applicable).
        switch(parseInt(v)) {
            case 1:
                Quote.set('financialRefereeType', 2, chunk);
                this.setDefaultPaymentFrequency(financialRefereeNumber, 2);
                break;
            case 2:
                Quote.set('financialRefereeType', 1, chunk);
                break;
            case 4:
                Quote.set('financialRefereeType', 4, chunk);
                this.setDefaultPaymentFrequency(financialRefereeNumber, 2);
                break;
        }

        if (v !== 3 && v !== 7) {
            Quote.set('financialRefereeStatus', (parseInt(financialRefereeNumber) + 1), chunk);
        }

        // For the first financial referee, we need to set the employmentStatus
        // for the BaseIndividualApplication as well.
        if (financialRefereeNumber === 0) {
            Quote.set('employmentStatus', parseInt(v), 'BaseIndividualApplication');
        }

        if (financialRefereeNumber === 0 && v === 6) {
            this.resetOnIndependentMeans(() => {
                this.handleFinancialRefereeTypeAndEmploymentStatus(financialRefereeNumber, fieldName, v);
            });
        } else {
            this.setState({
                allowRefereeTwo: true,
                allowRefereeThree: true,
            }, () => {
                this.handleFinancialRefereeTypeAndEmploymentStatus(financialRefereeNumber, fieldName, v);
            });
        }
    }

    /**
     * Sets financialRefereeType for all financial referees. Sets the
     * employmentStatus for the BaseIndividualApplication on the first financial
     * referee, and handles state change to pass to the EmploymentPeriod
     * component to render the correct financial referee sub-form.
     *
     * @param financialRefereeNumber
     * @param fieldName
     * @param v
     */
    handleFinancialRefereeTypeAndEmploymentStatus(financialRefereeNumber, fieldName, v) {
        if (financialRefereeNumber === 0 && v === 6) {
            this.resetOnIndependentMeans();
        } else {
            this.setState({
                allowRefereeTwo: true,
                allowRefereeThree: true,
            });
        }

        // Force financialRefereeStatus for anything other than student or
        // unemployed
        if (v !== 3 && v !== 7) {
            // Set up which form type we want to show for the given financial
            // referee and employment status.
            this.handleSubFormVisibility(financialRefereeNumber, v);
            this.setState({ isStudentOrUnemployedOnly: false });
        } else {
            // Set student/unemployed message to prevent adding more financial
            // referees, and clear all existing financial referee data.
            this.setState({ isStudentOrUnemployedOnly: true });
            Quote.deleteByPath('BaseIndividualApplication.financialReferees');
        }
    }

    render() {
        let product = Quote.getByPath('BaseIndividualApplication.product.productId');
        return(
            <div>
                <HeaderSteps current={4} />
                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                />
                <question-row class="header-row">
                    <h2>Current Employment</h2>
                </question-row>

                <Field
                    fieldName="employmentStatus"
                    type="radio-group"
                    question="What is your primary source of income?"
                    source={'BaseIndividualApplication'}
                    storageKey="employmentStatus"
                    options={[
                        {
                            value: 1,
                            text: 'Employed'
                        },
                        {
                            value: 2,
                            text: 'Self-employed'
                        },
                        {
                            value: 6,
                            text: 'I\'m of independent means'
                        },
                        {
                            value: 4,
                            text: 'In receipt of a pension'
                        },
                        {
                            value: 3,
                            text: 'Student'
                        },
                        {
                            value: 7,
                            text: 'Unemployed'
                        },
                    ]}
                    loadingKey={'BaseIndividualApplication.employmentStatus'}
                    loadValues={true}
                    callbackFunction={this.handleFinancialRefereeTypeAndEmploymentStatusCallback.bind(this, 0)}
                    onLoadFunction={this.handleFinancialRefereeTypeAndEmploymentStatus.bind(this, 0)}
                />

                {this.state.isStudentOrUnemployedOnly === true ?
                    <question-row>
                        <div className="question-main">
                            <p className="supplemental">
                                Please click next to continue.
                            </p>
                        </div>
                    </question-row>
                : null}

                {/* FINANCIAL REFEREE 1 */}
                {!this.state.isStudentOrUnemployedOnly && this.state.showFinancialRefereeOne === true ?
                    <div>
                        <EmploymentPeriod
                            productId={product}
                            termLength={this.state.termLength}
                            forceFinancialRefereeTwo={this.mustSelectFinancialRefereeTwo.bind(this)}
                            ref={(instance) => {this.childComponents.push(instance);}}
                            formType={this.state.financialRefereeOneType}
                            source={'BaseIndividualApplication.financialReferees.0'}
                        />

                        {/* Xpress - cannot enter more than one financial referee. */}
                        {/* If self-employed and changing in duration of tenancy term, we don't ask this, we force a second financial referee */}
                        {product !== 11 && this.state.mustSelectFinancialRefereeTwo !== true && this.state.allowRefereeTwo !== false ?
                            <Field
                                question={'Do you want to add another source of income?'}
                                type="button-choice"
                                fieldName={'wantSecondFinancialReferee'}
                                options={[
                                    {
                                        value: true,
                                        text: 'Yes'
                                    },
                                    {
                                        value: false,
                                        text: 'No'
                                    }
                                ]}
                                dataValidation="required_field"
                                onLoadFunction={this.handleCurrentEmploymentChanging.bind(this)}
                                callbackFunction={(defaultValue) => {
                                    Quote.deleteByPath('BaseIndividualApplication.financialReferees.1.financialRefereeStatus');
                                    Quote.deleteByPath('BaseIndividualApplication.financialReferees.1.financialRefereeType');
                                    this.handleCurrentEmploymentChanging(defaultValue);
                                }}
                                loadValues={true}
                                overwriteDefaultValue={() => {
                                    if (window.uorn(Quote.getByPath('BaseIndividualApplication.financialReferees.1.financialRefereeType'))) {
                                        return false;
                                    }
                                    return true;
                                }}
                                ref={(instance) => {this.inputComponents.push(instance);}}
                            />
                        : null}
                    </div>
                : null}

                {/* FINANCIAL REFEREE 2 */}
                {!this.state.isStudentOrUnemployedOnly && (this.state.showFinancialRefereeTwo === true || this.state.isCurrentEmploymentChanging === true || this.state.mustSelectFinancialRefereeTwo === true) ?
                    <div>
                        <question-row class="header-row">
                            <h2>Second Employment</h2>
                        </question-row>

                        {/* @TODO: Tom - this loading value will not work because the values are not correct for financialRefereeType */}
                        <Field
                            fieldName="financialRefereeTypeTwo"
                            type="radio-group"
                            question="Employment type"
                            options={[
                                {
                                    value: 1,
                                    text: 'Employed'
                                },
                                {
                                    value: 2,
                                    text: 'Self-employed'
                                },
                                {
                                    value: 4,
                                    text: 'In receipt of a pension'
                                },
                            ]}
                            loadingKey={'BaseIndividualApplication.financialReferees.1.financialRefereeType'}
                            loadValues={true}
                            callbackFunction={this.handleFinancialRefereeTypeAndEmploymentStatusCallback.bind(this, 1)}
                            onLoadFunction={this.handleFinancialRefereeTypeAndEmploymentStatus.bind(this, 1)}
                            overwriteDefaultValue={() => {
                                let ref = Quote.getByPath('BaseIndividualApplication.financialReferees.1');
                                if (!window.uorn(ref) && !window.uorn(ref.financialRefereeType)) {
                                    switch (ref.financialRefereeType) {
                                        case 2:
                                            return 1;
                                        case 4:
                                            return 4;
                                        case 6:
                                        case 1:
                                        case 5:
                                            return 2;
                                    }
                                }
                                return null;
                            }}
                        />

                        {this.state.financialRefereeTwoType ?
                            <div>
                                <EmploymentPeriod
                                    productId={product}
                                    termLength={this.state.termLength}
                                    forceFinancialRefereeThree={this.mustSelectFinancialRefereeThree.bind(this)}
                                    ref={(instance) => {this.childComponents.push(instance);}}
                                    formType={this.state.financialRefereeTwoType}
                                    source={'BaseIndividualApplication.financialReferees.1'}
                                />

                                {/* Xpress - cannot enter more than one financial referee. */}
                                {/* If self-employed and changing in duration of tenancy term, we don't ask this, we force a second financial referee */}
                                {product !== 11 && this.state.mustSelectFinancialRefereeThree !== true && this.state.allowRefereeThree !== false ?
                                    <Field
                                        question={'Do you want to add another source of income?'}
                                        type="button-choice"
                                        fieldName={'wantThirdFinancialReferee'}
                                        options={[
                                            {
                                                value: true,
                                                text: 'Yes'
                                            },
                                            {
                                                value: false,
                                                text: 'No'
                                            }
                                        ]}
                                        dataValidation="required_field"
                                        onLoadFunction={this.handleSecondEmploymentChanging.bind(this)}
                                        callbackFunction={(defaultValue) => {
                                            Quote.deleteByPath('BaseIndividualApplication.financialReferees.2.financialRefereeStatus');
                                            Quote.deleteByPath('BaseIndividualApplication.financialReferees.2.financialRefereeType');
                                            this.handleSecondEmploymentChanging(defaultValue);
                                        }}
                                        loadValues={true}
                                        overwriteDefaultValue={() => {
                                            if (window.uorn(Quote.getByPath('BaseIndividualApplication.financialReferees.2.financialRefereeType'))) {
                                                return false;
                                            }
                                            return true;
                                        }}
                                        ref={(instance) => {this.inputComponents.push(instance);}}
                                    />
                                : null}
                            </div>
                        : null}
                    </div>
                : null}

                {/* FINANCIAL REFEREE 3 */}
                {!this.state.isStudentOrUnemployedOnly && (this.state.showFinancialRefereeThree === true || this.state.isSecondEmploymentChanging === true || this.state.mustSelectFinancialRefereeThree === true) ?
                    <div>
                        <question-row class="header-row">
                            <h2>Third Employment</h2>
                        </question-row>

                        <Field
                            fieldName="financialRefereeTypeThree"
                            type="radio-group"
                            question="Employment type"
                            options={[
                                {
                                    value: 1,
                                    text: 'Employed'
                                },
                                {
                                    value: 2,
                                    text: 'Self-employed'
                                },
                                {
                                    value: 4,
                                    text: 'In receipt of a pension'
                                },
                            ]}
                            loadingKey={'BaseIndividualApplication.financialReferees.2.financialRefereeType'}
                            loadValues={true}
                            callbackFunction={this.handleFinancialRefereeTypeAndEmploymentStatusCallback.bind(this, 2)}
                            onLoadFunction={this.handleFinancialRefereeTypeAndEmploymentStatus.bind(this, 2)}
                            overwriteDefaultValue={() => {
                                let ref = Quote.getByPath('BaseIndividualApplication.financialReferees.2');
                                if (!window.uorn(ref) && !window.uorn(ref.financialRefereeType)) {
                                    switch (ref.financialRefereeType) {
                                        case 2:
                                            return 1;
                                        case 4:
                                            return 4;
                                        case 6:
                                        case 1:
                                        case 5:
                                            return 2;
                                    }
                                }
                                return null;
                            }}
                        />

                        {this.state.financialRefereeThreeType ?
                            <EmploymentPeriod
                                productId={product}
                                termLength={this.state.termLength}
                                ref={(instance) => {this.childComponents.push(instance);}}
                                formType={this.state.financialRefereeThreeType}
                                source={'BaseIndividualApplication.financialReferees.2'}
                            />
                        : null}
                    </div>
                : null}

                <SaveForLaterModal
                    ref="SaveForLaterModal"
                />

                <SubmitInput
                    label="Next"
                    callbackFunction={this.manualStepProgression.bind(this)}
                    backLink={true}
                    saveForLater={false}
                    saveForLaterFunc={() => {
                        this.setState({ isFullPageSpinnerActive: true });
                        HttpService.applicationPutApplication(() => {
                            window.localStorage.removeItem('validationError');
                            this.setState({ isFullPageSpinnerActive: false });
                            this.refs.SaveForLaterModal.toggleIsActive();
                        }, (invalidData) => {
                            window.localStorage.setItem('validationError', JSON.stringify(invalidData));
                            browserHistory.push('/error/applicant-validation');
                        });
                    }}
                    currentNumber={4}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/EmploymentDetails.js